import { createLocaleContext } from 'fbtee'
import es_CLTranslations from '../translations/es_CL.json'

export const availableLanguages = new Map([
  ['en_US', 'English'],
  ['es_CL', 'Español'],
])

const storedLocale = localStorage.getItem('beacon_locale')
const clientLocales = storedLocale
  ? [storedLocale, navigator.language, ...navigator.languages]
  : [navigator.language, ...navigator.languages]

export const LocaleContext = createLocaleContext({
  availableLanguages,
  clientLocales,
  fallbackLocale: 'en_US',
  translations: { es_CL: es_CLTranslations.es_CL },
  loadLocale: async (locale: string) => {
    if (locale === 'es_CL') {
      return es_CLTranslations.es_CL
    }
    return {}
  },
})
